"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseTreatmentFields = exports.createEmptyPayload = exports.TREATMENT_VARIATION_FIELD = exports.EXPERIMENT_ITERATION_FIELD = exports.EXPERIMENT_FAMILY_FIELD = exports.LINE_OF_BUSINESS_FIELD = void 0;
var TREATMENT_NAME_DELIMITER = '_';
var TREATMENT_NAME_COMPONENTS_COUNT = 4;
var LINE_OF_BUSINESS_FIELD = 'lineOfBusiness';
exports.LINE_OF_BUSINESS_FIELD = LINE_OF_BUSINESS_FIELD;
var EXPERIMENT_FAMILY_FIELD = 'experimentFamily';
exports.EXPERIMENT_FAMILY_FIELD = EXPERIMENT_FAMILY_FIELD;
var EXPERIMENT_ITERATION_FIELD = 'experimentIteration';
exports.EXPERIMENT_ITERATION_FIELD = EXPERIMENT_ITERATION_FIELD;
var TREATMENT_VARIATION_FIELD = 'treatmentVariation';
exports.TREATMENT_VARIATION_FIELD = TREATMENT_VARIATION_FIELD;

var createEmptyPayload = function createEmptyPayload() {
  var _ref;

  return _ref = {}, _ref[LINE_OF_BUSINESS_FIELD] = '', _ref[EXPERIMENT_FAMILY_FIELD] = '', _ref[EXPERIMENT_ITERATION_FIELD] = '', _ref[TREATMENT_VARIATION_FIELD] = '', _ref;
};

exports.createEmptyPayload = createEmptyPayload;

var parseTreatmentFields = function parseTreatmentFields(treatmentName) {
  var _ref2;

  if (typeof treatmentName === 'undefined' || treatmentName === null) {
    return createEmptyPayload();
  }

  var nameComponents = treatmentName.split(TREATMENT_NAME_DELIMITER);

  if (nameComponents.length !== TREATMENT_NAME_COMPONENTS_COUNT) {
    return createEmptyPayload();
  }

  return _ref2 = {}, _ref2[LINE_OF_BUSINESS_FIELD] = nameComponents[0], _ref2[EXPERIMENT_FAMILY_FIELD] = nameComponents[1], _ref2[EXPERIMENT_ITERATION_FIELD] = nameComponents[2], _ref2[TREATMENT_VARIATION_FIELD] = nameComponents[3], _ref2;
};

exports.parseTreatmentFields = parseTreatmentFields;